import { ID } from "@closerplatform/closer-sdk";
import { config } from "@fidget/common/config/config";

export class ForeTypingStore {
  private typingUsers: Map<string, number> = new Map();

  updateTypingUser(
    userId: ID,
    onStartedTyping: (userId: ID) => void,
    onStoppedTyping: (userId: ID) => void
  ): void {
    const maybeTimer = this.typingUsers.get(userId);

    if (maybeTimer) {
      clearTimeout(maybeTimer);
    } else {
      onStartedTyping(userId);
    }

    const timer = window.setTimeout(() => {
      onStoppedTyping(userId);
      this.typingUsers.delete(userId);
    }, config.services.times.chatTypingTimeoutMillis);

    this.typingUsers.set(userId, timer);
  }
}
